module.exports = __webpack_public_path__ + "static/media/new-dashboard.1c27d787.jpg";